module.exports = __webpack_public_path__ + "img/ssyx_24.873386d3.jpg";